import { create } from 'zustand';

const PENDING_RSVP_LIFETIME_MS = 10 * 60 * 1000;

type PendingRsvp = {
  eventID: string;
  expiresAt: number;
};

const usePendingEventActionStore = create<{
  pendingRsvp: PendingRsvp | null;
  setPendingRsvp: (pendingRsvp: PendingRsvp | null) => void;
}>((set) => ({
  pendingRsvp: null,
  setPendingRsvp: (pendingRsvp) => set({ pendingRsvp }),
}));

export function queuePendingRsvp(eventID: string, now = Date.now()) {
  usePendingEventActionStore.getState().setPendingRsvp({
    eventID,
    expiresAt: now + PENDING_RSVP_LIFETIME_MS,
  });
}

export function consumePendingRsvp(eventID: string, now = Date.now()) {
  const { pendingRsvp, setPendingRsvp } = usePendingEventActionStore.getState();
  if (!pendingRsvp || pendingRsvp.eventID !== eventID) {
    return false;
  }

  setPendingRsvp(null);
  return pendingRsvp.expiresAt >= now;
}
